import { render } from "./AttendanceCategory.vue?vue&type=template&id=64a725fb&scoped=true"
import script from "./AttendanceCategory.vue?vue&type=script&lang=js"
export * from "./AttendanceCategory.vue?vue&type=script&lang=js"

import "./AttendanceCategory.vue?vue&type=style&index=0&id=64a725fb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a725fb"]])

export default __exports__